import { EmpeDriveService } from '@/services/empe-drive';
import useSWR from 'swr';

export const useAlbums = (limit: number) => {
    return useSWR(limit ? `/albums?limit=${limit}` : null, () => EmpeDriveService.getAlbums(limit));
};
